import { toast } from "react-toastify"
import LogoDefault from "../assets/AircrewPortPages_default.svg"
import LogoRose from "../assets/AircrewPortPages_rose.svg"
import LogoMint from "../assets/AircrewPortPages_mint.svg"
import LogoSunset from "../assets/AircrewPortPages_sunset.svg"

const logos = {
    default: LogoDefault,
    rose: LogoRose,
    mint: LogoMint,
    sunset: LogoSunset,
}

// Module-level theme ref, kept current by useThemedToastSync()
let _theme = null
let _scheme = "default"

/**
 * Call this from a mounted component (e.g. Layout) to keep the theme in sync.
 * Returns nothing — it just writes to the module-level ref.
 */
export function syncTheme(theme, scheme) {
    _theme = theme
    _scheme = scheme
}

/**
 * Show a themed toast notification.
 * @param {object} options
 * @param {string} options.title - Bold heading text
 * @param {string} [options.body] - Secondary body text
 * @param {number} [options.autoClose=5000] - Auto-close duration in ms
 */
export function themedToast({ title, body, autoClose = 5000 }) {
    const logo = logos[_scheme] || logos.default

    const style = _theme
        ? {
              "--toastify-color-progress-light": _theme.palette.primary.main,
              "--toastify-color-progress-dark": _theme.palette.primary.main,
              background: _theme.palette.background.paper,
              borderLeft: `4px solid ${_theme.palette.primary.main}`,
              borderRadius: _theme.shape.borderRadius,
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
          }
        : {}

    const titleColor = _theme?.palette.text.primary || "#fff"
    const bodyColor = _theme?.palette.text.secondary || "rgba(255,255,255,0.6)"

    toast(
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img
                src={logo}
                alt=""
                style={{ width: 36, height: 36, flexShrink: 0 }}
            />
            <div>
                <div
                    style={{ fontWeight: 600, fontSize: 14, color: titleColor }}
                >
                    {title}
                </div>
                {body && (
                    <div
                        style={{
                            fontSize: 13,
                            color: bodyColor,
                            marginTop: 2,
                        }}
                    >
                        {body}
                    </div>
                )}
            </div>
        </div>,
        { autoClose, style }
    )
}
